import styled from 'styled-components';

export const ContentContract = styled.div`
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 25px 0px;
  width: 1100px;
  background: #fff;
  img {
    margin: 20px 0;
  }
  label {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: -0.01em;
    color: var(--color-primary-light);
    &:first-child {
      margin: 20px;
    }
  }
  h1 {
    margin-top: 20px;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 35px;
    line-height: 30px;
    color: #666666;
    text-align: center;
  }
  section {
    width: 580px;
    form {
      display: flex;
      flex-direction: column;
      button {
        margin-top: -90px;
        z-index: 0;
        position: inherit;
        height: 60px;
        background: var(--color-primary-light);
        border-radius: 4px;
        border: none;
        color: #fff;
        transition: 0.2s all;
        &:hover {
          background: var(--color-primary-dark);
        }
      }
      div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 20px;
        margin: 10px 0;
        img {
          margin-right: 10px;
        }
        a {
          align-items: center;
          text-decoration: none;
          display: flex;
          flex-direction: row;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 14px;
          color: #0db14b;
        }
      }
    }
  }
  @media only screen and (max-width: 786px) {
    width: 95%;
    section {
      width: 90%;
      form {
        display: flex;
        flex-direction: column;
        button {
          margin-top: -90px;
          z-index: 0;
          position: inherit;
          height: 60px;
          background: var(--color-primary-light);
          border-radius: 4px;
          border: none;
          color: #fff;
          transition: 0.2s all;
          &:hover {
            background: var(--color-primary-dark);
          }
        }
        div {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          height: 20px;
          margin: 10px 0;
          img {
            margin-right: 10px;
          }
          a {
            align-items: center;
            text-decoration: none;
            display: flex;
            flex-direction: row;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 14px;
            color: #0db14b;
          }
        }
      }
    }
  }
`;
